// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__1Hxhk","open-overlay":"Overlay_open-overlay__3WXTY","clear":"Overlay_clear__1FXL8"};